import React, { useState, useEffect } from "react"
import title from "../../assets/images/statisticsIndexTitle.png"
import ztTitle from "../../assets/images/zt_statisticsIndexTitle.png"
import "./index.less"
import { getStatisticsIndex } from "@/service/homeService"
import * as echarts from "echarts"
import chinajson from "@/utils/china.js"
import fullS from "../../assets/images/full-screen.png"
import fullSC from "../../assets/images/full-screen-cancel.png"
import { IS_TEST } from '../../config/app'
let echartCarType, echartTeam, vehiclePowerRanking, echartMap
export default () => {
    const [data, setData] = useState({})
    const [showFull, setShowFull] = useState(false) //是否展示全屏
    const [selectedQuarterLabel, setSelectedQuarterLabel] = useState("")
    useEffect(() => {
        getgetStatisticsData()
        let interval = setInterval(() => {
            getgetStatisticsData()
        }, 5000)
        return () => {
            clearInterval(interval)
        }
    }, [])

    const getgetStatisticsData = () => {
        getStatisticsIndex().then((res) => {
            setData(res.retData)
        })
    }
    const workerRankingGroupMap = (data.workerRanking || []).reduce((groupMap, item) => {
        const quarterLabel = item.quarterLabel || ""
        if (!groupMap[quarterLabel]) {
            groupMap[quarterLabel] = []
        }
        groupMap[quarterLabel].push(item)
        return groupMap
    }, {})
    const workerRankingQuarterLabels = Object.keys(workerRankingGroupMap).filter((item) => item)
    const currentWorkerRanking =
        workerRankingGroupMap[selectedQuarterLabel]?.length > 0
            ? workerRankingGroupMap[selectedQuarterLabel]
            : workerRankingGroupMap[workerRankingQuarterLabels[0]] || []

    useEffect(() => {
        if (!workerRankingQuarterLabels.length) {
            setSelectedQuarterLabel("")
            return
        }
        if (workerRankingGroupMap["本季度"]?.length > 0) {
            setSelectedQuarterLabel("本季度")
            return
        }
        if (!workerRankingGroupMap[selectedQuarterLabel]?.length) {
            setSelectedQuarterLabel(workerRankingQuarterLabels[0])
        }
    }, [data.workerRanking]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (data.vehiclePowerRanking) {
            getvehiclePowerRanking()
        }
        if (data.vehicleBrandRanking) {
            getCarType()
        }
        if (currentWorkerRanking.length) {
            getTeam()
        }
        getMap()
    }, [data, selectedQuarterLabel]) // eslint-disable-line react-hooks/exhaustive-deps

    const getMap = () => {
        if (!echartMap) {
            echartMap = echarts.init(document.getElementById("map"))
        }
        echarts.registerMap("china", chinajson)
        var dataMap = [
            { name: "霍尔果斯", coord: [80.42, 44.2], level: 3 },
            { name: "乌鲁木齐", coord: [87.68, 43.77], level: 1 },
            { name: "喀什", coord: [75.99, 39.47], level: 2 },
            { name: "林芝", coord: [94.36,29.65], level: 2 },
            { name: "额济纳", coord: [101.06,41.95], level: 3 },
            { name: "甘其毛都", coord: [107.58,42.41], level: 3 },
             { name: "呼和浩特", coord: [111.65, 40.82], level: 2 },
              { name: "银川", coord: [106.27, 38.47], level: 1 },
               { name: "西宁", coord: [101.74, 36.56], level: 2 },
            { name: "兰州", coord: [103.73, 36.03], level: 2 },
             { name: "成都", coord: [104.06, 30.67], level: 1 },
              { name: "西安", coord: [108.95, 34.27], level: 1 },
              { name: "重庆", coord: [106.54, 29.59], level: 2 },
               { name: "昆明", coord: [102.73, 25.04], level: 1 },
            { name: "贵阳", coord: [106.71, 26.57], level: 1 },
             { name: "南宁", coord: [108.33, 22.84], level: 2 },
              { name: "北京", coord: [116.46, 39.92], level: 1 },
              { name: "天津", coord:[117.2, 39.13], level: 1 },
              { name: "太原", coord: [112.53, 37.87], level: 1 },
              { name: "石家庄", coord:  [114.48, 38.03], level: 1 },
            { name: "青岛", coord: [120.33, 36.07], level: 1 },
            { name: "济南", coord: [117, 36.65], level: 1 },
            { name: "郑州", coord: [113.65, 34.76], level: 1 },
            { name: "武汉", coord: [114.31, 30.52], level: 2 },
            {name: "南昌", coord:  [115.89, 28.68], level: 2 },
             { name: "长沙", coord: [113, 28.21], level: 1 },
            { name: "广州", coord: [113.23, 23.16], level: 1 },
             { name: "深圳", coord: [114.07, 22.62], level: 1 },
             { name: "福州", coord: [119.3, 26.08], level: 1 },
             { name: "杭州", coord: [120.19, 29.96], level: 1 },
             { name: "上海", coord: [121.48, 31.22], level: 1 },
             { name: "南京", coord:  [118.78, 32.04], level: 1 },
             { name: "合肥", coord: [117.27, 31.06], level: 1 },
             { name: "沈阳", coord: [123.38, 41.8], level: 1 },
             { name: "大连", coord: [121.62, 38.92], level: 2 },
             { name: "长春", coord: [125.35, 43.88], level: 2 },
             { name: "哈尔滨", coord:  [126.63, 45.75], level: 1 },
            { name: "二连浩特", coord: [111.98, 43.65], level: 3 },
            { name: "满洲里", coord: [117.38, 49.6], level: 3 },
            { name: "海口", coord: [110.35, 20.02], level: 2 },
            {name:"绥芬河", coord: [131.15,44.41], level: 3 },
            { name: "南通", coord: [121.05, 32.28], level: 4 },
        ]
        const levelMap = {
            1: { name: "区域总部", color: "#66ff33" },
            2: { name: "所属区域", color: "#f5a623" },
            3: { name: "二级网络", color: "#8e35d9" },
            4: { name: "存储管理基地", color: "blue" },
        }
        const levelKeys = Object.keys(levelMap)
        const convertData = (level) =>
            dataMap
                .filter((item) => item.level === level)
                .map((item) => ({
                    name: item.name,
                    value: item.coord,
                    level: item.level,
                }))
                .filter((item) => item.value)
        let option = {
            // backgroundColor: '#fff',
            geo: {
                center: [101.670801, 35.818311],
                type: "map",
                map: "china",
                roam: false,
                geoIndex: 1,
                // zoom: window.screen.width < 1920 ? 1.6 : 1.8, //地图的比例
                zoom: 1.6, //地图的比例
                label: {
                    emphasis: {
                        textStyle: {
                            color: "red", //选中后的字体颜色
                        },
                    },
                },
                itemStyle: {
                    normal: {
                        areaColor: "#1bc1eb",
                        borderColor: "#1e75aa",
                    },
                    emphasis: {
                        areaColor: "#1fd7e9",
                    },
                },
            },
            legend: {
                orient: "vertical",
                left: "3%",
                bottom: "8%",
                itemWidth: 12,
                itemHeight: 12,
                textStyle: {
                    color: "#fff",
                    fontSize: 14,
                },
                data: levelKeys.map((key, index) => index < 3 ? levelMap[key].name : ""),
            },
            tooltip: {
                trigger: "item",
                formatter: (params) => `${params.name}<br />${levelMap[params.data.level]?.name || ""}`,
            },
            series: levelKeys.map((key) => ({
                name: levelMap[key].name,
                type: "effectScatter",
                coordinateSystem: "geo",
                data: convertData(Number(key)),
                symbolSize: 8,
                label: {
                    show: true,
                    formatter: function (params) {
                        let str = params.name
                        return str
                    },
                    position: "right",
                },
                itemStyle: {
                    color: levelMap[key].color,
                },
            })),
        }
        echartMap.setOption(option)
    }

    const getvehiclePowerRanking = () => {
        if (!vehiclePowerRanking) {
            vehiclePowerRanking = echarts.init(document.getElementById("vehiclePowerRanking"))
        }
        let dataSeries = []
        data.vehiclePowerRanking.forEach((item) => {
            dataSeries.push({
                value: item.nodeValue,
                name: item.nodeName,
            })
        })
        const option = {
            tooltip: {
                trigger: "item",
            },
            legend: {
                bottom: "0px",
                itemWidth: 10,
                itemHeight: 10,
                textStyle: {
                    fontSize: 10,
                    color: "#fff",
                },
            },
            series: [
                {
                    name: "动力来源",
                    type: "pie",
                    radius: "60%",
                    center: ["50%", "40%"],
                    data: dataSeries,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                    label: {
                        fontStyle: "normal",
                        alignTo: "edge",
                        formatter: "{name|{b}}\n{value|{c}}%",
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 15,
                        color: "#fff",
                        rich: {
                            time: {
                                fontSize: 10,
                                color: "#999",
                            },
                        },
                    },
                },
            ],
        }

        vehiclePowerRanking.setOption(option, true)
    }

    const getTeam = () => {
        if (!echartTeam) {
            echartTeam = echarts.init(document.getElementById("team"))
        }
        let dataAxis = []
        let dataY = []
        let nameArr = []
        currentWorkerRanking.forEach((item) => {
            nameArr.push(item.nodeName)
            dataAxis.push(item.nodeName)
            dataY.push(item.nodeValue)
        })
        const axisLabel = window.screen.width < 1500 ? { fontSize: 8 } : {}
        let option = {
            tooltip: {
                trigger: "axis",
                formatter: function (params) {
                    let str = nameArr[params[0].dataIndex] + "<br />" + "维修合计：" + params[0].value + "单"
                    return str
                },
            },
            xAxis: {
                data: dataAxis,
                axisLabel: {
                    color: "#fff",
                    ...axisLabel,
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                z: 10,
            },
            yAxis: {
                axisLine: {
                    show: false,
                },
                axisTick: {
                    show: false,
                },
                axisLabel: {
                    color: "#fff",
                },
            },
            dataZoom: [
                {
                    type: "inside",
                },
            ],
            grid: {
                top: "10%",
                bottom: "15%",
            },
            series: [
                {
                    type: "bar",
                    showBackground: true,
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: "#83bff6" },
                            { offset: 0.5, color: "#188df0" },
                            { offset: 1, color: "#188df0" },
                        ]),
                    },
                    emphasis: {
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: "#2378f7" },
                                { offset: 0.7, color: "#2378f7" },
                                { offset: 1, color: "#83bff6" },
                            ]),
                        },
                    },
                    data: dataY,
                    label: {
                        show: true,
                        position: "top",
                        color: "#fff",
                    },
                },
            ],
        }

        echartTeam.setOption(option, true)
    }

    const getCarType = () => {
        if (!echartCarType) {
            echartCarType = echarts.init(document.getElementById("carType"))
        }

        let dataSeries = []
        data.vehicleBrandRanking.forEach((item) => {
            dataSeries.push({
                value: item.nodeValue,
                name: item.nodeName,
            })
        })

        const option = {
            tooltip: {
                trigger: "item",
            },
            legend: {
                bottom: "0px",
                // itemWidth: window.screen.width < 1500 ? 10 : 15,
                // itemHeight: window.screen.width < 1500 ? 10 : 15,
                itemWidth: 10,
                itemHeight: 10,
                textStyle: {
                    // fontSize: window.screen.width < 1500 ? 10 : 15,
                    fontSize: 10,
                    color: "#fff",
                    marginTop: "100px",
                },
                type: "scroll",
                height: 200,
            },
            series: [
                {
                    name: "车辆品牌",
                    type: "pie",
                    radius: ["30%", "60%"],
                    center: ["50%", "40%"],
                    data: dataSeries,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                    label: {
                        fontStyle: "normal",
                        alignTo: "edge",
                        formatter: "{name|{b}}\n{value|{c}}辆",
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 15,
                        color: "#fff",
                        rich: {
                            time: {
                                fontSize: 10,
                                color: "#999",
                            },
                        },
                    },
                },
            ],
        }
        echartCarType.setOption(option, true)
    }

    const resize = async () => {
        console.log(echartTeam)
        console.log(echartCarType)
        console.log(vehiclePowerRanking)
        if (echartTeam && echartTeam.resize && echartCarType && echartCarType.resize && vehiclePowerRanking && vehiclePowerRanking.resize) {
            console.log(888)
            echartTeam.resize()
            echartCarType.resize()
            vehiclePowerRanking.resize()
        } else {
            setTimeout(() => {
                console.log(999)
                resize()
            }, 500)
        }
    }
    return (
        <div className={`statisticsIndexBox  ${showFull ? "full-screen" : ""}`}>
            <div
                className="full-screen-btn"
                onClick={() => {
                    setShowFull(!showFull)
                    setTimeout(() => {
                        echartMap.resize()
                    }, 0)
                }}
            >
                <img src={showFull ? fullS : fullSC} />
            </div>
            <div className="statisticsIndex">
                <img src={ IS_TEST ? ztTitle : title} className="titles" />
                <div className="statisticsContent">
                    <div className="left">
                        <div className="left-top statistics-item">
                            <div className="statistics-item-title">实时统计</div>
                            <div className="statistics-item-main">
                                <div className="left-top-bar left-top-bar1">
                                    <div className="left-top-bar-name">上线客户总数</div>
                                    <div className="left-top-bar-num" style={{ color: "rgba(247, 204, 62, 1)" }}>
                                        {(data && data.summary && data.summary.totalCustomerNum) || "--"}
                                    </div>
                                </div>
                                <div className="left-top-bar left-top-bar2">
                                    <div className="left-top-bar-name">维修工单总数</div>
                                    <div className="left-top-bar-num" style={{ color: "rgba(0, 246, 255, 1)" }}>
                                        {(data && data.summary && data.summary.totalOrderNum) || "--"}
                                    </div>
                                </div>
                                <div className="left-top-bar left-top-bar3">
                                    <div className="left-top-bar-name">经营流水总额</div>
                                    <div className="left-top-bar-num" style={{ color: "rgba(245, 86, 86, 1)" }}>
                                        {(data && data.summary && data.summary.totalFlow) || "--"}
                                    </div>
                                </div>
                                <div className="left-top-bar left-top-bar5 ">
                                    <div className="left-top-bar-name">商城订单总数</div>
                                    <div className="left-top-bar-num" style={{ color: "rgba(219, 219, 48, 1)" }}>
                                        {(data && data.shopOrder && data.shopOrder.shopOrderNum) || "--"}
                                    </div>
                                </div>
                                {/* <div className="left-top-bar left-top-bar4">
                                    <div className="left-top-bar-name">商城流水</div>
                                    <div className="left-top-bar-num" style={{ color: "#F53333" }}>
                                        {(data && data.shopOrder && data.shopOrder.shopOrderAmount) || "--"}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="left-bottom statistics-item">
                            <div className="statistics-item-title">动力来源占比</div>
                            <div className="statistics-item-main" id="vehiclePowerRanking"></div>
                        </div>
                    </div>
                    <div className="center">
                        <div className="center-top">
                            <div className="center-top-title">
                                为
                                {data &&
                                    data.summary &&
                                    data.summary.totalVehicleNum.split("").map((item, index) => {
                                        return <div key={index} className={`imgNum${item}`} />
                                    })}
                                台车辆保驾护航
                            </div>
                            <div className="map-box" id="map"></div>
                        </div>
                        <div className="center-bottom">
                            <div className="center-bottom-bar statistics-item">
                                <div className="center-bottom-name">今日上线客户</div>
                                <div className="center-bottom-num"> {(data && data.summary && data.summary.todayCustomerNum) || "--"}</div>
                                <div className="center-bottom-name" style={{ marginTop: "10%" }}>
                                    今日上线车辆
                                </div>
                                <div className="center-bottom-num"> {(data && data.summary && data.summary.todayVehicleNum) || "--"}</div>
                            </div>
                            <div className="center-bottom-center statistics-item">
                                <div>
                                    <div className="center-bottom-name2">今日工单数量</div>
                                    <div className="center-bottom-num2"> {(data && data.summary && data.summary.todayOrderNum) || "--"}</div>
                                </div>
                                <div>
                                    <div className="center-bottom-name2">今日维修流水</div>
                                    <div className="center-bottom-num2"> {(data && data.summary && data.summary.todayOrderAmount) || "--"}</div>
                                </div>
                            </div>
                            <div className="center-bottom-bar statistics-item">
                                <div className="center-bottom-name">今日商城订单</div>
                                <div className="center-bottom-num"> {(data && data.shopOrder && data.shopOrder.shopTotayOrderNum) || "--"}</div>
                                <div className="center-bottom-name" style={{ marginTop: "10%" }}>
                                    今日商城流水
                                </div>
                                <div className="center-bottom-num"> {(data && data.shopOrder && data.shopOrder.shopTotayOrderAmount) || "--"}</div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <div className="right-top statistics-item">
                            <div className="statistics-item-title">车辆品牌分类</div>
                            <div className="statistics-item-main" id="carType"></div>
                        </div>

                        <div className="right-bottom statistics-item">
                            <div className="statistics-item-title" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <span>创业班组工单量</span>
                                <div style={{ display: "flex", gap: 8 }}>
                                    {workerRankingQuarterLabels.map((label) => (
                                        <span
                                            key={label}
                                            onClick={() => setSelectedQuarterLabel(label)}
                                            style={{
                                                cursor: "pointer",
                                                padding: "2px 8px",
                                                borderRadius: 12,
                                                border: `1px solid ${selectedQuarterLabel === label ? "#66ff33" : "#7d8aa5"}`,
                                                color: selectedQuarterLabel === label ? "#66ff33" : "#fff",
                                                fontSize: 12,
                                                lineHeight: "18px",
                                            }}
                                        >
                                            {label}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            <div className="statistics-item-main" id="team"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
